import * as React from 'react';

import { NavigationTrackerSource } from '../../ReactComponents/NavigationTracker/NavigationTracker';
import { NavigationTrackerLink } from '../../ReactComponents/NavigationTracker/NavigationTrackerLink';
import { FarmasietLinkViewModel } from './FarmasietLinkViewModel.csharp';
import { LinkDisplayOption } from './LinkDisplayOption.csharp';

export interface FarmasietLinkProps {
    model: FarmasietLinkViewModel;
    className?: string;
    trackingSource?: NavigationTrackerSource;
}

export const FarmasietLink = (props: FarmasietLinkProps) => {
    const rel = () => {
        switch (props.model.displayOption) {
            case LinkDisplayOption.Follow:
                return 'follow';
            case LinkDisplayOption.NoFollow:
                return 'nofollow';
            case LinkDisplayOption.NoFollowNoOpener:
                return 'nofollow noopener';
        }
    };

    return (
        <div className={props.className}>
            {(props.trackingSource && (
                <NavigationTrackerLink
                    href={props.model.link.href}
                    target={props.model.link.target}
                    rel={rel()}
                    source={props.trackingSource}
                    disableTracking={!props.model.trackNavigation}
                >
                    {props.model.link.text}
                </NavigationTrackerLink>
            )) || (
                <a href={props.model.link.href} target={props.model.link.target} rel={rel()}>
                    {props.model.link.text}
                </a>
            )}
        </div>
    );
};
